import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CodeFormatService {
	/**
	 * This function takes a Gen3 hasp code and formats it in the desired display format
	 * by adding a 1 to the front of it and a - after the 4th digit. So it's passed
	 * in like 1234567 and gets formatted to 1123-4567
	 */
	formatGen3HaspCode(haspCode: string): string {
		let formattedHaspCode = '1' + haspCode.replace(/\D/g, '');
		formattedHaspCode =
			formattedHaspCode.slice(0, 4) + '-' + formattedHaspCode.slice(4);

		return formattedHaspCode;
	}
}
